<template>
	<div class="item_sidebar lazyload_bool" :class="{warn:(recommended && !value)}">
		<div class="wrapper_title mb_0">
			<div class="title">
				<span>Lazyload?</span>

				<info-icon warn v-if="recommended && !value.booleanValue"
				           info="We highly recommend keeping lazy-loading on for best customer page experience."/>
			</div>

			<label class="switch_checkbox_item">
				<input type="checkbox" :checked="value.booleanValue" @change="updatedData($event.target.checked)">
				<div class="switch_checkbox"><span></span></div>
			</label>
		</div>
	</div>
</template>

<script>
import InfoIcon from '@/components/base/info-icon';

export default {
	name: 'LazyloadBool',
	components: {InfoIcon},
	props: ['title', 'value', 'options','content'],
	methods: {
		updatedData(val) {
			this.$emit('updated', {booleanValue:val});
		},
	},
	computed: {
		recommended(){
			return this.options && this.options.recommended;
		}
	}
}
</script>
<style lang="scss" scoped>
.lazyload_bool {
	.title {
		display: flex;
		flex-direction: row;
		flex: 1;
	}
	&.warn {
		.title{
			color: #FDCC5E !important;
		}
	}
}
</style>
